import axiosClient from "..";
import { getErrorMessageObj } from "../../../container/SportsBookNode/utils/common/functions";

export default class topSponsoredEventService {
  static getTopSponsoredEvent(payload) {
    return axiosClient
      .get("/sb/getSponsored", {
        params: { ...payload }
      })
      .then(({ data }) => {
        return data;
      })
      .catch((error) => {
        return getErrorMessageObj(error);
      });
  }
}
